import Programs from "@/views/Programs.vue";
import ProgramDetails from "@/views/ProgramDetailsV2.vue";
import { authGuard, programPageGuard } from "@/auth/authGuard";

// The Programs list and the program detail routes. They live here so their guards can be
// tested without loading every view in the app (see programRoutes.test.js).
//
// displayProgramPage hides the Programs list only, so only the list gets programPageGuard
// (#189743). The detail routes stay on authGuard: the Program Dashboard, activity feed,
// leaderboard and program emails open programs through them, and closing them on the flag
// broke the dashboard for clients with the Programs page off (#193089).
export default [
  {
    path: "/programs",
    name: "programs",
    component: Programs,
    beforeEnter: programPageGuard,
  },
  {
    path: "/programs/:programId",
    name: "programdetails",
    component: ProgramDetails,
    props: true,
    beforeEnter: authGuard,
  },
  {
    path: "/programs/:programId/dynamic",
    name: "dynamicprogramdetail",
    component: () => import("@/views/DynamicProgramView.vue"),
    props: true,
    meta: { permission: "vue:read:programdetails" },
    beforeEnter: authGuard,
  },
];
